import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { FileSearch } from 'lucide-react';
import { BatchProcessingProgress } from './BatchProcessingProgress';
/**
 * Side-sheet wrapper that hosts the existing BatchProcessingProgress component
 * in its full-detail form. The sheet is purely presentational — all polling and
 * status logic live in the shared ProposalProgressProvider.
 */ export function ProposalProgressSheet({ projectId, batchId, open, onOpenChange }) {
    return /*#__PURE__*/ _jsx(Sheet, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(SheetContent, {
            side: "right",
            className: "w-[560px] sm:w-[640px] overflow-y-auto p-0",
            "data-testid": Testids.proposalProgress.sheet,
            children: [
                /*#__PURE__*/ _jsxs(SheetHeader, {
                    className: "sticky top-0 z-10 border-b border-gray-100 bg-white px-6 pb-4 pt-6",
                    children: [
                        /*#__PURE__*/ _jsxs(SheetTitle, {
                            className: "flex items-center gap-2 text-base",
                            children: [
                                /*#__PURE__*/ _jsx(FileSearch, {
                                    className: "h-4 w-4 text-blue-600"
                                }),
                                "Document analysis"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mt-1 text-xs text-gray-500",
                            children: "Per-document progress, cross-document analysis phases, and extraction counts."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "p-4",
                    children: /*#__PURE__*/ _jsx(BatchProcessingProgress, {
                        projectId: projectId,
                        batchId: batchId
                    })
                })
            ]
        })
    });
}
